// src/redux/reducers/cityReducer.js
import {
    FETCH_GETALLORGS_FAILURE,
    FETCH_GETALLORGS_REQUEST,
    FETCH_GETALLORGS_SUCCESS, 
    SET_SELECTED_GETALLORGS ,
  } from '../types'; 
  
  const initialState = {
    loading: false,
    getallorgsList: [],
    selectedgetallId: null, 
    error: null,
  };
  
  const getAllOrgsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETALLORGS_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETALLORGS_SUCCESS:
        return { ...state, loading: false, getallorgsList: action.payload };
      case FETCH_GETALLORGS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETALLORGS:
        return { ...state, selectedgetallId: action.payload };
      default:
        return state;
    }
  };
  
  export default getAllOrgsReducer;



  